<template>
	<v-sheet elevation="0" max-width="700px" class="mx-auto">
		<FunctionTitle :title="''" />
		<CommonFlame :title="'ERPログイン'">
			<v-form ref="form" v-model="isValid" class="pa-2">
				<UserFormEmail :email.sync="user.email" />
				<UserFormPassword :password.sync="user.password" login />
				<v-row no-gutters justify="center" class="mt-4">
					<v-btn :disabled="!isValid" class="btn" color="secondary" @click.prevent="login">
						<v-icon class="mr-2"> mdi-login </v-icon>
						ログイン</v-btn
					>
				</v-row>
				<v-row no-gutters class="my-4" justify="end">
					<router-link class="button" :to="{ name: 'password_reset' }"
						>パスワードを忘れた方はこちらから</router-link
					>
				</v-row>
			</v-form>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import UserFormEmail from "../../view/user/forms/UserFormEmail.vue"
import UserFormPassword from "../../view/user/forms/UserFormPassword.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		UserFormEmail,
		UserFormPassword,
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			user: {
				email: null,
				password: null,
			},
			isValid: false,
		}
	},
	mounted() {
		authenticate.unauthenticateUser()
	},
	methods: {
		login() {
			this.$store
				.dispatch("auth/login", {
					email: this.user.email,
					password: this.user.password,
				})
				.then((res) => {
					if (res.message) {
						this.$store.dispatch("setFlash", {
							text: res.message,
							type: "notice",
						})
					} else {
						this.$store.dispatch("setFlash", {
							text: "ログインしました",
							type: "notice",
						})
					}
					if (res.user_include_sales == true) {
						this.$router.push("/")
					}
					if (res.user_include_sales == false && res.user_include_sales !== null) {
						this.$router.push("/erp")
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		isSetValid() {
			if (this.user.email !== "" && this.user.password !== "") {
				return false
			} else {
				return true
			}
		},
	},
}
</script>
